'use client';

import React, { createContext, useMemo, useState } from 'react';

import { UserResponse } from 'utils/GeneratedApi';

type AuthenticatedUserContextType = React.Context<{
  user?: UserResponse | undefined;
  setUser: (user: UserResponse) => void;
}>;

const AuthenticatedUserContext: AuthenticatedUserContextType = createContext({
  setUser: (user: UserResponse) => {
    console.log('user info from context', user);
  },
});

const AuthenticatedUserProvider = ({
  userData,
  children,
}: {
  userData: UserResponse | undefined;
  children: React.ReactNode;
}) => {
  const [user, setUser] = useState(userData);
  const value = useMemo(() => ({ user, setUser }), [user]);
  /*
   * We can only have one type of user. Please do not mix

  const { data } = useSession();

  useEffect(() => {
    if (data?.user) {
      setUser(data?.user as User);
    }
  }, [data?.user]);
  */
  return (
    <AuthenticatedUserContext.Provider value={value}>{children}</AuthenticatedUserContext.Provider>
  );
};

export { AuthenticatedUserContext, AuthenticatedUserProvider };
